import { TooltipProps, Tooltip, styled } from '@mui/material';
import tooltipClasses from '@mui/material/Tooltip/tooltipClasses';
import useIsMobile from '../../hooks/useIsMobile';
import { useState, useEffect } from 'react';

interface CustomTooltipProps extends TooltipProps {
  width?: string;
}

export const CustomTooltip = styled(
  ({ className, width: _width, ...props }: CustomTooltipProps) => {
    const isMobile = useIsMobile();
    const [open, setOpen] = useState(false);

    useEffect(() => {
      if (isMobile && open) {
        const handleDocumentClick = (e: MouseEvent | TouchEvent) => {
          const target = e.target as HTMLElement;
          if (
            !target.closest('.MuiTooltip-popper') &&
            !target.closest('[aria-describedby]')
          ) {
            setOpen(false);
          }
        };

        document.addEventListener('click', handleDocumentClick);
        document.addEventListener('touchstart', handleDocumentClick);

        return () => {
          document.removeEventListener('click', handleDocumentClick);
          document.removeEventListener('touchstart', handleDocumentClick);
        };
      }
    }, [isMobile, open]);

    const handleTooltipOpen = () => {
      if (isMobile) {
        setOpen(true);
      }
    };

    const handleTooltipClose = () => {
      if (!isMobile) {
        setOpen(false);
      }
    };

    const handleClick = (e: React.MouseEvent) => {
      if (isMobile) {
        e.stopPropagation();
        setOpen(!open);
      }
    };

    const tooltipProps = isMobile
      ? {
          ...props,
          open: props.open !== undefined ? props.open : open,
          onOpen: handleTooltipOpen,
          onClose: handleTooltipClose,
          disableHoverListener: true,
          disableFocusListener: true,
          disableTouchListener: true,
          onClick: handleClick,
        }
      : {
          ...props,
          enterTouchDelay: 50,
          leaveTouchDelay: 3000,
        };

    return <Tooltip {...tooltipProps} classes={{ popper: className }} />;
  }
)<{ width?: string }>(({ theme, width }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary,
    boxShadow: theme.shadows[3],
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1.5),
    width: width || 'auto',
    maxWidth: width ? 'none' : '80vw',
    fontSize: theme.typography.pxToRem(14),
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
  },
}));
